
const wishesButton = document.getElementById('wishes-submit-button');
const addMoreButton = document.getElementById('wishes-add-more-button');
const modalOpenerButtton = document.querySelector('.wishes-modal > button');
const wishesForm = document.getElementById('wishes-form');
const modalDialogWishes = document.querySelector('.modal-dialog-wishes');

const sucessMessageWrapper = document.querySelector('.wishes-sucess-message');
const inputs = wishesForm.querySelectorAll('.wishes__input');
const wishesLoadingState = document.getElementById('wishes-loading-state');
const wishesSelectorsWrapper = document.getElementById('wishes-selectors-wrapper');
const wishesFormFields = document.getElementById('wishes-form-fields');

let observerModalWsihes = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === "attributes") {
      if(!modalDialogWishes.hasAttribute('open')) {
        inputs.forEach(input => {
          const errorMessage = input.parentNode.lastElementChild;
          errorMessage.classList.add('hidden');
        });
        modalOpenerButtton.blur();
        wishesForm.classList.remove("hidden");
        sucessMessageWrapper.classList.add('hidden');
        wishesForm.reset();
      }
    }
  });
});

observerModalWsihes.observe(modalDialogWishes, {
  attributes: true
});



async function initWishOptions() {
  const result = await fetchWishesOptions(global.partnerUuid, wishOptionParams.parentSku, wishOptionParams.colorStyle);
  const { wishOptions: { colors, sizes } = {} } = result || {};
  const sizeSelect = document.getElementById('size-select')
  const colorSelect = document.getElementById('color-select')

  colors?.forEach((color) => {
    const colorOption = document.createElement('option');
    colorOption.textContent = color.displayName;
    colorOption.setAttribute('value', color.code);
    colorSelect.appendChild(colorOption);
  });

  sizes?.forEach((size) => {
    const sizeOption = document.createElement('option');
    sizeOption.textContent = size.display;
    sizeOption.setAttribute('value', size.code);
    sizeSelect.appendChild(sizeOption);
  });

  wishesLoadingState.classList.add('hidden');
  wishesSelectorsWrapper.classList.remove('hidden');
  wishesFormFields.classList.remove('hidden');
}
  
let wishOptionsLoaded = false;
modalOpenerButtton.addEventListener('click', () => {
  if (!wishOptionsLoaded) {
    wishOptionsLoaded = true;
    initWishOptions();
  }
});

function toggleSubmitButton() {
  wishesButton.disabled = !wishesForm.checkValidity();
}

inputs.forEach(input => {
  input.addEventListener('blur', function () {
    toggleErrorMessage(input, true);
  });
})

wishesForm.addEventListener('input', function (e) {
    toggleErrorMessage(e.target);
});

addMoreButton.addEventListener('click', () => { 
  wishesForm.classList.remove("hidden");
  sucessMessageWrapper.classList.add('hidden');
});

wishesForm.addEventListener('invalid', ( () => {
  return function (e) {
    const errorMessage = e.target.parentNode.lastElementChild;
    errorMessage.classList.remove('hidden');
    //prevents the HTML buble to pop up 
    e.preventDefault();
  };
})(), true);

wishesForm.addEventListener('submit', async function (event) {
  event.preventDefault();

  if (wishesForm.checkValidity()) {
    const sizeSelector = document.getElementById('size-select');
    const colorSelector = document.getElementById('color-select')

    const filter = {size: [sizeSelector.value]};
    if (wishOptionParams.colorStyle == 'color_family') {
      filter.colorFamily = [colorSelector.value];
    } else {
      filter.color = [colorSelector.value];
    }
    
    const email = document.getElementById('email-address').value;
    const emailMarketing = document.getElementById('email-marketing');

    try {
      if(emailMarketing?.checked) {
        await emailOptIn(global.partnerUuid, email);
      }
      const wishResponse = await wishCreate(global.partnerUuid, wishOptionParams.parentSku, filter, email);
      if(wishResponse?.wishCreate?.uuid) {
        wishesForm.classList.add("hidden");
        sucessMessageWrapper.classList.remove('hidden');
        wishesForm.reset();
      }
    } catch (error) {
      console.error(e)
    }
  }
  return;
});

function toggleErrorMessage(input, show = false) {
  const errorMessage = input.parentNode.lastElementChild;

  if (input?.id === 'email-marketing') return;

  if (input.validity?.valid) {
    errorMessage.classList.add('hidden');
  } else if (show) {
    errorMessage.classList.remove('hidden');
  }
  if (input.value) {
    input.classList.add('filled');
  } else if (show) {
    input.classList.remove('filled');
  }
}

/**
 * Fetch the data wishes options by parentsku
 * @param {*} variables
 * @param {String} parentSku
 * @returns returns the colors and sizes options
 */
async function fetchWishesOptions(partnerUuid,parentSku,colorStyle) {
    const query = `
      query wishOptions(
        $partnerUuid: String! 
        $parentSku: String!
        $colorStyle: String!
        ){
          wishOptions(
            partnerUuid: $partnerUuid,
            parentSku: $parentSku,
            colorStyle: $colorStyle
            ) {
            colors {
              code
              displayName
              url
              type
            }
            sizes {
              code
              display
            }
          }
        }
    `;
    const param = 'query-wishOptions';
    try {
      const response = await fetchWithAppName(`${global.url}${param}`, {
        body: JSON.stringify({ query, variables: { partnerUuid, parentSku, colorStyle } }),
      });
      const jsonData = await response.json();
      return jsonData.data;
    } catch (e) {
      console.error(e);
    }
  }

/**
 * Create a wish
 * @param {*} partnerUuid
 * @returns 
 */
async function wishCreate(partnerUuid, parentSku, filter, email) {
    const query = `
      mutation wishCreate(
        $parentSku: String!
        $filter: JSON
        $email: String!
        $partnerUuid: String!
      ) {
        wishCreate(
          partnerUuid: $partnerUuid
          parentSku: $parentSku
          filter: $filter
          email: $email
        ) {
          uuid
          ycustomerUuid
        }
      }
    `;
    const param = 'query-wishCreate';
    try {
      const response = await fetchWithAppName(`${global.url}${param}`, {
        body: JSON.stringify({ query, variables: { partnerUuid, parentSku, filter, email  } }),
      });
      const jsonData = await response.json();
      return jsonData.data;
    } catch (e) {
      console.error(e);
    }
  }

  async function  emailOptIn(partnerUuid, email) {
    const query = `
      mutation emailOptIn(
        $partnerUuid: String!
        $email: String!
      ) {
        emailOptIn(email: $email, partnerUuid: $partnerUuid) {
          email
        }
      }
    `;
    const param = 'query-emailOptIn';
    try {
      const response = await fetchWithAppName(`${global.url}${param}`, {
        body: JSON.stringify({ query, variables: { partnerUuid, email } }),
      });
      const jsonData = await response.json();
      return jsonData.data;
    } catch (e) {
      console.error(e);
    }
  }
